import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {
    linkList: [],
    linkData: {
        linkName: '',
        longurl: '',
        domain: '',
        allowShort: '',
        backHalf: '',
        protocol: '',
        pathLength: '',
        allowTracking: '',
        isDynamic: '',
        shortURL: ''
    },
    fileData: [],
    bulkLinkData: [],
    totalUploads: 0
}
const getters = {
    getTableData: (state) => state.linkList,
    getLinkData: (state) => state.linkData,
    getFileData: (state) => state.fileData,
    getbulkLinkData: (state) => state.bulkLinkData,
    getTotalUploads: (state) => state.totalUploads
}
const mutations = {
    SET_TABLE_DATA (state, payload) {
        state.linkList = payload
    },
    SET_LINK_DATA (state, payload) {
        state.linkData.linkName = payload.Name
        state.linkData.longurl = payload.LongURL
        state.linkData.domain = payload.Domain
        state.linkData.allowShort = payload.AllowShortURL
        state.linkData.backHalf = payload.CustomBackHalf
        state.linkData.protocol = payload.Protocol
        state.linkData.pathLength = payload.PathLength
        state.linkData.isDynamic = payload.DynamicURL
        state.linkData.allowTracking = payload.AllowTracking
        state.linkData.shortURL = payload.ShortURL
    },
    SET_BULK_LINK_DATA (state, payload) {
        state.bulkLinkData = payload.data
        state.totalUploads = parseInt(payload.total.counts)
    }
}
const actions = {
    async shortUrl ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.link.set, payload)
            if (resp.data && resp.data.displayMsg && resp.data.displayMsg.s) {
                Toastr.success(resp.data.displayMsg.s.head, resp.data.displayMsg.s.msg)
            }
            return resp.data
        } catch (err) {
            console.log(err)
        }
    },
    async fetchLinks ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.link.get, payload)
            commit('SET_TABLE_DATA', resp.data)
        } catch (err) {
            console.log(err)
        }
    },
    async detail ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.link.detail, payload)
            commit('SET_LINK_DATA', resp.data)
            return resp.data
        } catch (err) {
            console.log(err)
        }
    },
    async uploadFile ({ commit }, payload) {
        let formData = new FormData()
        formData.append('file', payload.file)
        formData.append('type', payload.type)
        formData.append('isDynamic', payload.isDynamic)
        formData.append('uploadName', payload.uploadName)
        formData.append('cta', payload.cta)
        formData.append('protocol', payload.protocol)
        formData.append('domain', payload.domain)
        formData.append('identifier', payload.identifier)
        formData.append('shortUrl', payload.shortUrl)
        formData.append('pathLength', payload.pathLength)

        try {
            const response = await this.$axios.post(API_PATH.link.bulkUpload, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response
        } catch (error) {
            Toastr.error(`Error uploading file`, 'Error')
        }
    },
    async fetchFileUploads ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.link.bulkGet, payload)
            commit('SET_BULK_LINK_DATA', resp.data)
        } catch (err) {
            console.log(err)
        }
    },
    async downloadFile ({ commit }, payload) {
        try {
            const response = await this.$axios.post(`${API_PATH.link.downloadFile}`, payload)
            return response
        } catch (error) {
            Toastr.error(`Error downloading file`, 'Error')
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
